<script setup lang="ts">
import type {Testimonial} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  testimonial: Populated<Testimonial>
}>()

const person = {
  name: props.testimonial.person,
  image: props.testimonial.image,
  role: props.testimonial.role ?? undefined,
  partnerName: props.testimonial?.partner?.name,
}
</script>

<template>
  <div class="rounded-lg bg-white p-2 bordershadow-input-light">
    <div class="rounded bg-white p-6 bordershadow-gray">
      <Paragraph size="medium" weight="normal" class="mb-8 !text-gray-600">
        {{ testimonial.message }}
      </Paragraph>

      <Person image-variant="grayscale" :person="person" />
    </div>
  </div>
</template>
